function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceSick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16,6A10,10,0,1,0,26,16h0A10,10,0,0,0,16,6Zm6,12H18v4H14V18H10V14h4V10h4v4h4Z",
    style: {
      fill: "#e54918"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceSick);
export default __webpack_public_path__ + "static/media/presence-sick.fe28120b.svg";
export { ForwardRef as ReactComponent };